import { TicketDTO, WhenAskForFriendlyName, WhenAskForTableCompanions } from 'core/api';
import setTableCompanionsIfNeeded from '../utils/setTableCompanionsIfNeeded';
import setFriendlyNameIfNeeded from '../utils/setFriendlyNameIfNeeded';
import { CustomError, Result } from 'core/infrastructure';


type Params = {
	getTicket: () => TicketDTO,
	setTableCompanions: (tableCompanions: Nullable<number>) => Promise<Result<void, CustomError>>,
	setFriendlyName: (name: string) => Promise<void>,
}

export default async function makeTicketReadyToSale(params: Params) {

	const tableCompanionsResult = await setTableCompanionsIfNeeded({
		when: WhenAskForTableCompanions.OnOpenDocument,
		ticket: params.getTicket(),
		setTableCompanions: params.setTableCompanions
	});
	if (!tableCompanionsResult.ok) {
		return Result.error();
	}

	const friendlyNameResult = await setFriendlyNameIfNeeded({ when: WhenAskForFriendlyName.OnOpenTicket, setFriendlyName: params.setFriendlyName, ticket: params.getTicket() });
	if (!friendlyNameResult.ok) {
		return Result.error();
	}

	return Result.ok();
}